export default "__VITE_ASSET__18c6b42e__"